import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Button,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import RequestService from '../../services/RequestService';
import CustomSecureInput from '../inputs/CustomSecureInput';
import { ReactComponent as LockIcon } from '../../assets/icons/lock.svg';
import { ReactComponent as EyeIcon } from '../../assets/icons/eye.svg';
import logo from '../../assets/images/gameup_dark.png';

const ResetPasswordPage = () => {
    const [token, setToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(true);
    const [valid, setValid] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const t = searchParams.get('token');

        if (!t) {
            setError('Nenhum token encontrado na URL.');
            setLoading(false);
            return;
        }
        setToken(t);

        const validateToken = async () => {
            try {
                await RequestService.validateResetToken(t);
                setValid(true);
            } catch (err) {
                setError('Token inválido ou expirado.');
            } finally {
                setLoading(false);
            }
        };

        validateToken();
    }, [location]);

    const handleSubmit = async () => {
        if (newPassword !== confirmPassword) {
            setError('As senhas não coincidem.');
            return;
        }

        try {
            await RequestService.resetPassword(token, newPassword);
            alert('Senha redefinida com sucesso!');
            navigate('/login');
        } catch (err) {
            setError('Erro ao redefinir senha. Tente novamente.');
        }
    };

    if (loading) {
        return <Typography>Validando token...</Typography>;
    }

    if (!valid) {
        return (
            <Box sx={{ textAlign: 'center', mt: 5 }}>
                <Typography color="error" variant="h6">
                    {error || 'Token inválido ou expirado.'}
                </Typography>
                <Button variant="contained" onClick={() => navigate('/login')}>
                    Voltar para o login
                </Button>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#FFFFFF',
                padding: 2,
            }}
        >
            <Box
                sx={{
                    width: isMobile ? '90%' : '400px',
                    padding: isMobile ? 3 : 4,
                    borderRadius: 2,
                    textAlign: 'center',
                    backgroundColor: '#FFFFFF',
                }}
            >
                <Box
                    component="img"
                    src={logo}
                    alt="Logo"
                    sx={{
                        width: isMobile ? 195 : 227,
                        marginBottom: isMobile ? '32px' : '40px',
                    }}
                />
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontSize: '24px',
                        fontWeight: 500,
                        color: '#292929',
                        marginBottom: 3,
                    }}
                >
                    Crie uma nova senha
                </Typography>

                <CustomSecureInput
                    label="Insira sua nova senha"
                    placeholder="nova senha"
                    icon={LockIcon}
                    eyeIcon={EyeIcon}
                    onChange={(value) => setNewPassword(value)}
                    sx={{ marginBottom: '24px' }}
                />

                <CustomSecureInput
                    label="Confirmar nova senha"
                    placeholder="nova senha"
                    icon={LockIcon}
                    eyeIcon={EyeIcon}
                    onChange={(value) => setConfirmPassword(value)}
                />

                {error && (
                    <Typography color="error" sx={{ mb: 2 }}>
                        {error}
                    </Typography>
                )}

                <Button
                    fullWidth
                    variant="contained"
                    sx={{
                        mt: 3,
                        mb: '24px',
                        fontSize: '16px',
                        fontWeight: '500',
                        minHeight: '40px',
                        backgroundColor: '#1F83FF',
                        '&:hover': {
                            backgroundColor: '#1565C0',
                        },
                    }}
                    onClick={handleSubmit}
                >
                    Redefinir senha
                </Button>
            </Box>
        </Box>
    );
};

export default ResetPasswordPage;
